























import Vue from 'vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/app';

export default Vue.extend({
  name: 'Coming',
  async mounted() {
    if (process.env.VUE_APP_MODE === 'PROD') {
      (this as any).$gtm.trackView( location.pathname.toString() , location.toString());
    }
    localStorage.removeItem(NOC.N16.DIR);
  },
  methods: {
    async onClickMoveWELCOME() {
      this.$emit('change', NOC.APP.MODE.WELCOME);
    },
  },
});
